<agr-page-toolbar [pageTitle]="(pageTitle$ | async) ?? ''">
  <!-- General page introduction section -->
  <div class="dashboard-introduction spacing--padding-all">
    <div class="dashboard-introduction__content">
      <h2 class="text-color--primary-500">{{ 'goodday' | translate }} {{ (user$ | async)?.name }},</h2>
      <h3 class="text--light">{{ 'dashboardIntro' | translate }}</h3>
    </div>
    <div class="dashboard-introduction__selector">
      <app-crop-year-selector />
    </div>
  </div>
  <mat-divider></mat-divider>

  <section>
    <div class="spacing--padding-horizontal">
      <div class="insights-overview-header">
        <h2 class="text-color--primary-500 text--light spacing--margin-none-bottom">
          {{ 'insightsOverview' | translate }}
        </h2>
        <div class="insights-overview-header__actions">
          <app-stock-button />
          <app-sync-from-fms-button />
        </div>
      </div>
      <div class="widget-parent widget-parent--insights" [class.widget-parent--empty-insights]="emptyWidgetsLayout()">
        @for (widget of orderedWidgets(); track widget) {
          @switch (widget) {
            @case ('blight') {
              <app-blight-dashboard-widget />
            }
            @case ('downyMildew') {
              <app-downy-mildew-dashboard-widget />
            }
            @case ('virusMonitor') {
              <app-virus-monitor-dashboard-widget />
            }
            @case ('bfp') {
              <app-bfp-dashboard-widget />
            }
            @case ('advices') {
              @if (!isMobile()) {
                <app-widget-list class="list" />
              } @else {
                <mat-expansion-panel class="mobile-expansion-panel" [expanded]="true">
                  <mat-expansion-panel-header>
                    <mat-panel-title> {{ 'cropFieldsOverview' | translate }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <app-widget-list class="list" />
                </mat-expansion-panel>
              }
            }
          }
        }
      </div>
    </div>
  </section>
  <!-- Map widget & cropfields sidebar -->
  <section>
    <div class="spacing--padding-horizontal">
      <h2 class="text-color--primary-500 text--light spacing--margin-none-bottom">
        {{ 'arableCropFields' | translate }}
      </h2>
      <div class="widget-parent widget-parent--cropfields">
        <app-widget-map class="map" />
        <app-widget-environmental-impact-points class="list" />
      </div>
    </div>
  </section>

  <!-- Insights widgets -->
  <section>
    <div class="spacing--padding-horizontal">
      <h2 class="text-color--primary-500 text--light spacing--margin-none-bottom">
        {{ 'moreInsights' | translate }}
      </h2>
      <div id="insights" class="widget-parent widget-parent--insights">
        <app-eip-deliveries-widget />
        <app-widget-organic-matter-balance />
      </div>
    </div>
  </section>
</agr-page-toolbar>
